type GetProgressOptions = {
  currentTime: number;
  startTime: number;
  endTime: number;
};

type GetNewTimeOptions = {
  percentage: number;
  endTime: number;
  startTime: number;
};

export const getProgress = ({
  currentTime,
  endTime,
  startTime,
}: GetProgressOptions) => {
  const duration = endTime - startTime;
  const relativeCurrentTime = currentTime - startTime;
  const progress = duration > 0 ? relativeCurrentTime / duration : 0;
  return Math.min(Math.max(progress, 0), 1);
};

export const getSeekTimeByPercentage = ({
  percentage,
  endTime,
  startTime,
}: GetNewTimeOptions) => {
  const duration = endTime - startTime;
  const newTime = percentage * duration + startTime;
  return newTime;
};
